import { HttpClient, HttpContext } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { REQUEST_META_DATA } from '@seech-sub/core-ng';
import { Observable } from 'rxjs';
import { OperationsApiRoutes } from '../constants/operations.constants';
import {
  AlertRecipientDetail,
  AlertRecipientQuery,
  AlertRecipientSaveRequest,
  PagedResult,
} from '../models';

@Injectable({
  providedIn: 'root',
})
export class AlertRecipientClientService {
  private readonly quietContext = new HttpContext().set(REQUEST_META_DATA.HIDE_PROGRESS, true);
  private readonly http = inject(HttpClient);

  queryRecipients(query: AlertRecipientQuery): Observable<PagedResult<AlertRecipientDetail>> {
    return this.http.post<PagedResult<AlertRecipientDetail>>(OperationsApiRoutes.alertRecipientsQuery, query, {
      context: this.quietContext,
    });
  }

  getRecipient(id: string): Observable<AlertRecipientDetail> {
    return this.http.get<AlertRecipientDetail>(OperationsApiRoutes.alertRecipientById(id));
  }

  createRecipient(request: AlertRecipientSaveRequest): Observable<AlertRecipientDetail> {
    return this.http.post<AlertRecipientDetail>(OperationsApiRoutes.alertRecipients, request);
  }

  updateRecipient(id: string, request: AlertRecipientSaveRequest): Observable<AlertRecipientDetail> {
    return this.http.put<AlertRecipientDetail>(OperationsApiRoutes.alertRecipientById(id), request);
  }

  enableRecipient(id: string): Observable<AlertRecipientDetail> {
    return this.http.post<AlertRecipientDetail>(OperationsApiRoutes.alertRecipientEnable(id), {});
  }

  disableRecipient(id: string): Observable<AlertRecipientDetail> {
    return this.http.post<AlertRecipientDetail>(OperationsApiRoutes.alertRecipientDisable(id), {});
  }

  deleteRecipient(id: string): Observable<boolean> {
    return this.http.delete<boolean>(OperationsApiRoutes.alertRecipientById(id));
  }
}
